import { z } from 'zod';
import { trainingContentSchema } from './chapter';
import { questionSchema } from './question';

/**
 * The authored unit: identity + the gate threshold + the typed content + the
 * graded question bank (incl. answer keys). The seeder maps this onto a
 * bozp_hazard_profiles row and computes versionHash from content+questions.
 *
 * `title` is a PLAIN STRING (the value seeded verbatim into the varchar
 * `bozp_hazard_profiles.title` column - V1 Czech, locked-contract shape). Only
 * CHAPTER titles inside `content` are LocalizedText.
 */
export const trainingProfileSchema = z
  .object({
    slug: z.string().regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/, 'slug must be kebab-case'),
    title: z.string().min(1),
    passThreshold: z.number().int().min(1).max(100),
    content: trainingContentSchema,
    questions: z.array(questionSchema).min(1),
  })
  .strict();

export type TrainingProfile = z.infer<typeof trainingProfileSchema>;
